import { useState } from 'react';
import { FaCalendar, FaUsers, FaClock, FaExclamationTriangle } from 'react-icons/fa';
import RosterGrid from './RosterGrid';
import StaffManagement from './StaffManagement';
import LeaveManagement from './LeaveManagement';
import BenchedStaffPanel from './BenchedStaffPanel';
import './RosterDashboard.css';

const RosterDashboard = () => {
  const [activeTab, setActiveTab] = useState('roster');

  // Mock data since we can't use the useRoster hook
  const staff = [];
  const activeStaff = [];
  const benchedStaff = [];
  const shifts = [];
  const leaveRequests = [];
  const rosterEntries = [];
  const currentView = 'month';

  // Mock functions
  const generateRoster = (type) => {
    console.log(`Generating ${type} roster`);
  };

  const approveLeaveRequest = (id) => {
    console.log(`Approving leave request ${id}`);
  };

  const pendingLeaveRequests = leaveRequests.filter(req => req.status === 'pending');
  const totalShifts = rosterEntries.length;
  const averageStaffPerShift = totalShifts > 0 ? (rosterEntries.length / (shifts.length * 28)).toFixed(1) : '0';

  return (
    <div className="roster-dashboard min-h-screen bg-background p-6">
      <div className="mx-auto max-w-7xl space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold mb-1">Staff Roster Dashboard</h1>
            <p className="text-muted-foreground">Manage staff schedules, shifts, and leave requests</p>
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => generateRoster('weekly')}
              className="bttn-outline"
            >
              Generate Weekly Pattern
            </button>
            <button
              onClick={() => generateRoster('continuous')}
              className="bttn-outline"
            >
              Generate 28-Day Roster
            </button>
          </div>
        </div>

        {/* Stats Cards */}
        {/* Generate Roster Message */}
        {rosterEntries.length === 0 && (
          <div className="main-cards bg-#fff text-center">
            <FaCalendar size="40px" className="icon-md text-muted-foreground mx-auto mb-4 myIcon" />
            <h3 className="text-lg font-semibold p-0 mt-0 mb-2">No Roster Generated Yet</h3>
            <p className="text-muted-foreground p-0 mt-0">
              Click one of the buttons above to generate a staff roster for the next 28 days.
            </p>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <div className="main-info-cards">
            <div className="card-header flex flex-row items-center justify-between pb-2">
              <div className="card-title text-sm font-medium">Total Staff</div>
              <FaUsers className="icon text-muted-foreground" />
            </div>
            <div className="card-content">
              <div className="text-2xl font-bold">{staff.length}</div>
              <p className="text-xs text-muted-foreground">
                {activeStaff.length} active, {benchedStaff.length} benched
              </p>
            </div>
          </div>

          <div className="main-info-cards">
            <div className="card-header flex flex-row items-center justify-between pb-2">
              <div className="card-title text-sm font-medium">Total Shifts</div>
              <FaClock className="icon text-muted-foreground" />
            </div>
            <div className="card-content">
              <div className="text-2xl font-bold">{totalShifts}</div>
              <p className="text-xs text-muted-foreground">
                Avg {averageStaffPerShift} staff per shift
              </p>
            </div>
          </div>

          <div className="main-info-cards">
            <div className="card-header flex flex-row items-center justify-between pb-2">
              <div className="card-title text-sm font-medium">Pending Requests</div>
              <FaExclamationTriangle className="icon text-muted-foreground" />
            </div>
            <div className="card-content">
              <div className="text-2xl font-bold">{pendingLeaveRequests.length}</div>
              <p className="text-xs text-muted-foreground">
                Leave requests awaiting approval
              </p>
            </div>
          </div>

          <div className="main-info-cards">
            <div className="card-header flex flex-row items-center justify-between pb-2">
              <div className="card-title text-sm font-medium">Coverage</div>
              <FaCalendar className="icon text-muted-foreground" />
            </div>
            <div className="card-content">
              <div className="text-2xl font-bold">28</div>
              <p className="text-xs text-muted-foreground">
                Days planned ahead
              </p>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="flex gap-6">
          <div className="flex-1">
            <div className="tabs-container benched-staff-card">
              <div className="tabs-list grid grid-cols-3">
                <button
                  className={`tab-trigger ${activeTab === 'roster' ? 'active' : ''}`}
                  onClick={() => setActiveTab('roster')}
                >
                  Roster View
                </button>
                <button
                  className={`tab-trigger ${activeTab === 'staff' ? 'active' : ''}`}
                  onClick={() => setActiveTab('staff')}
                >
                  Staff Management
                </button>
                <button
                  className={`tab-trigger ${activeTab === 'leave' ? 'active' : ''}`}
                  onClick={() => setActiveTab('leave')}
                >
                  Leave Requests
                </button>
              </div>

              <div className="tab-content">
                {activeTab === 'roster' && (
                  <div className="space-y-4">
                    <RosterGrid />
                  </div>
                )}

                {activeTab === 'staff' && (
                  <div className="space-y-4">
                    <StaffManagement />
                  </div>
                )}

                {activeTab === 'leave' && (
                  <div className="space-y-4">
                    <LeaveManagement
                      leaveRequests={leaveRequests}
                      onApproveLeave={approveLeaveRequest}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Benched Staff Sidebar */}
          <div className="w-80">
            <BenchedStaffPanel />
          </div>
        </div>
      </div>
    </div>
  );
}

export default RosterDashboard;